import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHomeIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m8 2.21 6.25 5.93v6.11H1.75V7.92L8 2.21ZM8.01.5.5 7.37v8.13h15V7.6L8.01.5Z",
    fill: "currentColor"
  }));
}

export { SvgHomeIcon as default };
